document.addEventListener('DOMContentLoaded', function () {
  window.collectionTabEve();
  window.initializeInterTabObserver();

  function updateHeaderHeight() {
    const header = document.querySelector('#header');
    if (header) {
      const newHeightDesktop = header.offsetHeight;
      document.documentElement.style.setProperty('--custom-header-height', newHeightDesktop + 'px');
    }

    const mobileHeader = document.querySelector('#mobile-header');
    if (mobileHeader) {
      const newHeightMobile = mobileHeader.offsetHeight;
      document.documentElement.style.setProperty('--custom-mobile-header-height', newHeightMobile + 'px');
    }
  }
  updateHeaderHeight();
  window.addEventListener('resize', updateHeaderHeight);
});

window.collectionTabEve = function () {
  const menuItems = document.querySelectorAll('.category-card');
  menuItems.forEach(function (item) {
    let count = 0;
    item.addEventListener('click', function () {
      count++;
      if (document.querySelector(`#${this.dataset.href}`)) {
        document.querySelector(`#${this.dataset.href}`).scrollIntoView({ behavior: 'smooth' });
      }
      if (count == 1) {
        setTimeout(() => {
          item.click();
        }, 400);
      }
    });
  });
};

window.initializeInterTabObserver = function () {
  const items = document.querySelectorAll('.collection-product-card');
  let visibleMap = new Map();

  function getVisibleHeight(entry) {
    const rect = entry.boundingClientRect;
    const top = Math.max(rect.top, 0);
    const bottom = Math.min(rect.bottom, window.innerHeight);
    return Math.max(0, bottom - top);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const visibleHeight = getVisibleHeight(entry);
          visibleMap.set(entry.target, visibleHeight);
        } else {
          visibleMap.delete(entry.target);
        }
      });

      let mostVisibleEl = null;
      let maxHeight = 0;

      visibleMap.forEach((height, el) => {
        if (height > maxHeight) {
          maxHeight = height;
          mostVisibleEl = el;
        }
      });

      items.forEach((item) => item.classList.remove('active'));
      if (mostVisibleEl && !mostVisibleEl.classList.contains('active')) {
        document.querySelectorAll('.category-card').forEach((item) => item.classList.remove('active'));
        document.querySelector(`.category-card[data-href="${mostVisibleEl.dataset.id}"]`).classList.add('active');
      }
    },
    {
      threshold: Array.from({ length: 101 }, (_, i) => i / 100),
    }
  );

  items.forEach((item) => observer.observe(item));
};

class UpsellProductPdp extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeUpsellProduct(this.dataset.productId);
  }

  initializeUpsellProduct(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const upsellProduct = html.querySelector('upsell-product-pdp');

        if (upsellProduct && upsellProduct.querySelectorAll('.pdp__upsell').length > 0) {
          this.innerHTML = upsellProduct.innerHTML;
          window.selectChange();

          this.classList.remove('!tw-hidden');

          new Swiper(this.querySelector('.swiper-container'), {
            slidesPerView: 1.03,
            spaceBetween: 6,
            loop: false,
            freeMode: true,
            scrollbar: {
              el: this.querySelector('.swiper-scrollbar'),
              draggable: true,
            },
            mousewheel: {
              forceToAxis: true,
            },
            // pagination: {
            //   el: this.querySelector('.swiper-pagination'),
            //   clickable: true,
            // },
            breakpoints: {
              750: {
                slidesPerView: 1.8,
                spaceBetween: 6,
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: 6,
              },
              1280: {
                slidesPerView: 1.9,
                spaceBetween: 6,
              },
            },
          });
          // yotpo.initWidgets();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('upsell-product-pdp', UpsellProductPdp);

class AddVariantItem extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    // const id = this.dataset.id;
    // console.log(id);
    const selectedOptions = this.closest('.variant-swatch-btn-main').querySelectorAll('.selected-option');
    const selectedTexts = Array.from(selectedOptions).map((option) => option.textContent);
    const result = selectedTexts.join(' / ');

    const currentId = this.closest('.variant-swatch-btn-main').querySelector(
      `.default-variant-options option[value="${result}"]`
    ).dataset.id;
    console.log(currentId);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: currentId,
        quantity: 1,
      }),
    })
      .then(() => {
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();
      })
      .catch((error) => console.error('Error:', error));
  }
}

customElements.define('add-variant-item', AddVariantItem);

class CustomSwatchOption extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    this.closest('.option-swatch').querySelector('.selected-option').textContent = this.dataset.value;
    this.closest('.option-swatch')
      .querySelectorAll('custom-swatch-option')
      .forEach((i) => {
        i.classList.remove('active');
      });
    this.classList.add('active');

    const selectedOptions = this.closest('.variant-swatch-btn-main').querySelectorAll('.selected-option');
    const selectedTexts = Array.from(selectedOptions).map((option) => option.textContent);
    const result = selectedTexts.join(' / ');

    const currentVariant = this.closest('.variant-swatch-btn-main').querySelector(
      `.default-variant-options option[value="${result}"]`
    );

    const variantImg = currentVariant.dataset?.img;
    this.closest('.upsell-product-tile').querySelector('.upsell-product-tile-image img').src = variantImg;
  }
}

customElements.define('custom-swatch-option', CustomSwatchOption);

window.selectChange = function () {
  document.querySelectorAll('.select-option-main').forEach((select) => {
    select.onchange = function () {
      this.closest('.option-swatch').querySelector('.selected-option').textContent = this.value;
    };
  });
};

const accordions = document.querySelectorAll('.product__information .product-block--accordion');
accordions.forEach((el) => {
  el.classList.remove('is-first-accordion', 'is-last-accordion');
});
if (accordions.length > 0) {
  accordions[0].classList.add('is-first-accordion');
  accordions[accordions.length - 1].classList.add('is-last-accordion');
}

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[data-trigger-cart-drawer]');
  buttons.forEach((button) => {
    button.onclick = function (event) {
      document.querySelector('#theme-ajax-cart').classList.toggle('is-visible');
      document.querySelector('.ajax-cart__overlay').classList.toggle('is-visible');
    };
  });
});

class addBundle extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (document.querySelector(`.add-cart-form [name="id"]`) && document.querySelector(`.add-cart-form [name="add"]`)) {
      document.querySelector(`.add-cart-form [name="id"]`).value = this.dataset.id;
      document.querySelector(`.add-cart-form [name="add"]`).click();
    }
  }
}

customElements.define('add-bundle', addBundle);

class removeItem extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    Shopify.theme.quantityBox.updateCart(this.dataset.id, 0);
  }
}

customElements.define('remove-item', removeItem);

class UpsellProductCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeUpsellProduct(this.dataset.productId);
  }

  initializeUpsellProduct(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const upsellProduct = html.querySelector('upsell-product-cart');

        if (upsellProduct && upsellProduct.querySelectorAll('.cart__upsell').length > 0) {
          this.innerHTML = upsellProduct.innerHTML;
          window.selectChange();
          yotpo.initWidgets();
          this.classList.remove('!tw-hidden');

          new Swiper(this.querySelector('.swiper-container'), {
            slidesPerView: 1.03,
            spaceBetween: 6,
            loop: false,
            freeMode: true,
            scrollbar: {
              el: this.querySelector('.swiper-scrollbar'),
              draggable: true,
            },
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('upsell-product-cart', UpsellProductCart);
